export const Logo = ({ className = "", imgClassName = "h-14 w-auto" }) => (
  <span className={`inline-flex items-center ${className}`} data-testid="jomkonvoi-logo">
    <img
      src="/assets/logo.png"
      alt="JomKonvoi — Ride together, arrive together"
      className={imgClassName}
    />
  </span>
);
